import { useState } from "react";

const PINK = "#e4006d";
const DARK = "#0d0d1a";
const GRAY_BG = "#f5f5f7";

export default function SkyBroadband() {
  return (
    <div style={{ fontFamily: "'Sky Text', 'Segoe UI', Arial, sans-serif", color: "#1a1a1a", background: "#fff" }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { margin: 0; }
        a { color: #e4006d; text-decoration: none; }
        a:hover { text-decoration: underline; }

        .hero-inner {
          display: flex;
          align-items: stretch;
          justify-content: space-between;
          max-width: 1100px;
          margin: 0 auto;
          padding: 36px 40px;
          gap: 40px;
        }
        .hero-left {
          flex: 1 1 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #fff;
        }
        .hero-right {
          flex: 0 0 340px;
          background: #fff;
          border-radius: 6px;
          padding: 28px 28px 24px;
        }
        .price-box {
          display: flex;
          align-items: center;
          gap: 0;
          margin-top: 16px;
        }
        .price-card {
          background: #fff;
          border-radius: 8px;
          padding: 18px 28px;
          text-align: center;
          color: #1a1a1a;
        }
        .price-sep {
          font-size: 28px;
          font-weight: 900;
          color: #fff;
          padding: 0 18px;
        }
        .price-card2 {
          text-align: center;
          color: #fff;
        }
        .usp-strip {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          gap: 0;
          padding: 28px 40px;
          border-bottom: 1px solid #e5e5e5;
          max-width: 1100px;
          margin: 0 auto;
        }
        .usp-item {
          flex: 1 1 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 0 24px;
          border-right: 1px solid #e5e5e5;
        }
        .usp-item:last-child { border-right: none; }
        .speed-grid {
          display: flex;
          gap: 20px;
          justify-content: center;
          flex-wrap: wrap;
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 40px 48px;
        }
        .speed-card {
          flex: 1 1 220px;
          max-width: 320px;
          overflow: hidden;
          border: 1px solid #e0e0e0;
          background: #fff;
        }
        .steps-row {
          display: flex;
          gap: 0;
          justify-content: center;
          max-width: 900px;
          margin: 36px auto 0;
          flex-wrap: wrap;
        }
        .step-item {
          flex: 1 1 200px;
          text-align: center;
          padding: 0 28px;
          border-right: 1px solid #e0e0e0;
        }
        .step-item:last-child { border-right: none; }
        .explore-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 40px 48px;
        }
        .explore-card {
          overflow: hidden;
          background: #fff;
        }
        .faq-row {
          border-top: 1px solid #ddd;
          cursor: pointer;
        }
        .faq-q {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 0;
          font-size: 14px;
          font-weight: 600;
          color: #1a1a1a;
          background: none;
          border: none;
          width: 100%;
          text-align: left;
          cursor: pointer;
        }
        .faq-a {
          font-size: 14px;
          color: #444;
          line-height: 1.6;
          padding-bottom: 16px;
        }
        .footer-links {
          display: flex;
          flex-wrap: wrap;
          gap: 18px;
          justify-content: center;
          margin: 16px 0 12px;
        }

        @media (max-width: 768px) {
          .hero-inner {
            flex-direction: column;
            padding: 0;
            gap: 0;
          }
          .hero-left {
            padding: 20px 16px 16px;
          }
          .hero-right {
            border-radius: 0;
            margin: 0;
            padding: 20px 16px;
          }
          .price-box {
            flex-wrap: wrap;
            gap: 8px;
          }
          .price-sep { padding: 0 8px; }
          .usp-strip {
            flex-direction: column;
            padding: 0;
            gap: 0;
          }
          .usp-item {
            border-right: none;
            border-bottom: 1px solid #e5e5e5;
            flex-direction: row;
            text-align: left;
            align-items: flex-start;
            padding: 16px;
            gap: 14px;
          }
          .usp-item:last-child { border-bottom: none; }
          .speed-grid {
            flex-direction: column;
            align-items: center;
            padding: 0 16px 36px;
          }
          .speed-card { max-width: 100%; }
          .steps-row {
            flex-direction: column;
            align-items: center;
            margin: 24px auto 0;
            padding: 0 16px;
            gap: 28px;
          }
          .step-item { border-right: none; padding: 0; }
          .explore-grid {
            grid-template-columns: 1fr;
            padding: 0 16px 36px;
          }
          .section-pad { padding-left: 16px !important; padding-right: 16px !important; }
        }
      `}</style>

      {/* ── HERO BANNER ── */}
      <section style={{
        background: "linear-gradient(115deg, #cc006a 0%, #e0507a 28%, #eda060 65%, #f5d080 100%)",
      }}>
        <div style={{
          background: "rgba(0,0,0,0.12)",
          textAlign: "center",
          padding: "9px 16px",
          fontSize: 13,
          color: "#fff",
          fontWeight: 500,
        }}>
          Our lowest price is back
        </div>

        <div className="hero-inner">
          <div className="hero-left">
            <div style={{ fontSize: 12, fontWeight: 700, color: "rgba(255,255,255,0.88)", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 }}>
              Our lowest price is back
            </div>
            <div className="price-box">
              <div className="price-card">
                <div style={{ fontSize: 12, fontWeight: 700, color: "#666", marginBottom: 2 }}>Full Fibre 150</div>
                <div style={{ fontSize: 44, fontWeight: 900, color: "#1a1a1a", lineHeight: 1 }}>£24</div>
                <div style={{ fontSize: 12, color: "#888", marginTop: 3 }}>a month</div>
              </div>
              <div className="price-sep">+</div>
              <div className="price-card2">
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Switch and get up to</div>
                <div style={{ fontSize: 54, fontWeight: 900, lineHeight: 1 }}>£200</div>
                <div style={{ fontSize: 12, opacity: 0.85 }}>towards leaving fees</div>
              </div>
            </div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", marginTop: 13 }}>
              Price may change during 24 month minimum term
            </div>
          </div>

          <div className="hero-right">
            <h2 style={{ fontSize: 20, fontWeight: 800, color: "#1a1a1a", lineHeight: 1.3, marginBottom: 10 }}>
              Say hello to our best broadband deals
            </h2>
            <p style={{ fontSize: 13, color: "#555", lineHeight: 1.55, marginBottom: 18 }}>
              Faster is now easier with Full Fibre broadband that's right for you. Switch and claim up to £200 towards leaving fees.
            </p>
            <AvailabilityForm />
          </div>
        </div>
      </section>

      {/* ── USP STRIP ── */}
      <section style={{ background: "#fff", borderBottom: "1px solid #e5e5e5" }}>
        <div className="usp-strip">
          <UspItem
            icon={<SpeedIcon />}
            title="UK's fastest speeds"
            desc="From any major provider with speeds up to 1Gbps"
          />
          <UspItem
            icon={<ReliableIcon />}
            title="Ultra-reliable"
            desc="Full Fibre – the UK's most reliable broadband technology"
          />
          <UspItem
            icon={<PoundIcon />}
            badge="+ £"
            title="Up to £200 switching credit"
            desc="With 24/7 tech person support to get you up and running"
          />
        </div>
      </section>

      {/* ── SPEEDS ── */}
      <section style={{ background: "#fff", paddingTop: 48 }}>
        <h2 style={{ textAlign: "center", fontSize: 26, fontWeight: 800, color: "#1a1a1a", marginBottom: 28 }}>
          We have speeds for every home
        </h2>
        <div className="speed-grid">
          <SpeedCard
            name="Everyday essential"
            speed="67 Mbps – 100 Mbps"
            desc="Perfect for browsing, video calling and staying connected with family and friends."
            img="https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=500&q=80"
            bg="#ddd8f0"
          />
          <SpeedCard
            name="Busier homes"
            speed="300 Mbps – 500 Mbps"
            desc="Made for working from home and streaming your favourite shows and sports on multiple devices."
            img="https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=500&q=80"
            bg="#f0d8e8"
          />
          <SpeedCard
            name="Epic performance"
            speed="900 Mbps – 5 Gbps"
            desc="Our fastest speeds. Where 4K streaming and serious gaming go to the next level."
            img="https://images.unsplash.com/photo-1542751371-adc38448a05e?w=500&q=80"
            bg="#d8e8f4"
          />
        </div>
      </section>

      {/* ── SWITCH STEPS ── */}
      <section style={{ background: "#fff", padding: "52px 40px 60px", borderTop: "1px solid #efefef" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <h2 style={{ textAlign: "center", fontSize: 26, fontWeight: 800, color: "#1a1a1a" }}>
            Switch to Sky and claim up to<br />£200 towards your leaving fee
          </h2>
          <div className="steps-row">
            <StepItem n={1} title="Choose your plan" desc="Pick the perfect speed for you and we'll confirm your activation date." />
            <StepItem n={2} title="We'll handle the switch" desc="We'll tell your old provider you're leaving so you don't have to." />
            <StepItem n={3} title="Get online" desc="Plug in your Sky Hub on your activation date to get up and running with Sky Broadband." />
          </div>
        </div>
      </section>

      {/* ── EXPLORE ── */}
      <section style={{ background: "#fff", paddingTop: 48, borderTop: "1px solid #efefef" }}>
        <h2 style={{ textAlign: "center", fontSize: 26, fontWeight: 800, color: "#1a1a1a", marginBottom: 28 }}>
          Explore more about Sky Broadband
        </h2>
        <div className="explore-grid">
          <ExploreCard
            img="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&q=80"
            label="Full Fibre: Our most reliable broadband."
            desc="Full Fibre broadband can give you up to 5Gbps download speeds."
            link="Full Fibre Broadband and WiFi Max"
          />
          <ExploreCard
            img="https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=600&q=80"
            label="Sky Broadband: Built for gaming."
            desc="See how Sky Broadband can level up your gaming."
            link="Gaming on Sky Full Fibre Broadband"
          />
          <ExploreCard
            img="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt9bdb317d66489e17/691b0b9063a07c115206dccc/3.png?format=webp&imageManager=true&impolicy=resize&width=1000"
            label="WiFi Max: For a smarter, safer connection."
            desc="Add WiFi Max for our most advanced WiFi features."
            link="WiFi Max Information"
            link2="Starting on Sky Full Fibre Broadband"
          />
          <ExploreCard
            img="https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt6b1aa3d71bc0a593/691b0b90a655330838e83a58/4.png?format=webp&imageManager=true&impolicy=resize&width=1000"
            label="TV and Broadband: Together."
            desc="Take a look at our best deals on TV and Broadband."
            link="Sky TV and Broadband"
          />
        </div>
      </section>

      {/* ── FAQ ── */}
      <section style={{ background: "#fff", padding: "52px 40px 60px", borderTop: "1px solid #efefef" }}>
        <div style={{ maxWidth: 860, margin: "0 auto" }}>
          <h2 style={{ textAlign: "center", fontSize: 26, fontWeight: 800, color: "#1a1a1a", marginBottom: 28 }}>
            Frequently Asked Questions
          </h2>
          <FaqSection />
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{ background: "white", color: "#aaa", padding: "28px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ marginBottom: 14 }}>
            <svg width="52" height="24" viewBox="0 0 52 24">
              <ellipse cx="26" cy="12" rx="25" ry="11.5" fill="white"/>
              <text x="26" y="16.5" textAnchor="middle" fontSize="13" fontWeight="bold" fill="#001035" fontFamily="Arial">sky</text>
            </svg>
          </div>
          <div className="footer-links">
            {["Privacy options","Terms & conditions","Privacy & cookies notice","Accessibility","Sitemap","Contact us","Complaints"].map(l => (
              <a key={l} href="#" style={{ color: "#aaa", fontSize: 12 }}>{l}</a>
            ))}
          </div>
          <div style={{ fontSize: 11, color: "#555", marginTop: 8 }}>© 2026 Sky UK</div>
        </div>
      </footer>
    </div>
  );
}

/* ─── SUB-COMPONENTS ─── */

function AvailabilityForm() {
  const [postcode, setPostcode] = useState("");
  const [address, setAddress] = useState("");
  const inputStyle = {
    width: "100%", padding: "10px 12px",
    border: "1.5px solid #bbb", borderRadius: 3,
    fontSize: 14, outline: "none", marginBottom: 10,
    fontFamily: "inherit",
  };
  return (
    <div>
      <input type="text" placeholder="Postcode" value={postcode} onChange={e => setPostcode(e.target.value)} style={inputStyle} />
      <input type="text" placeholder="Address" value={address} onChange={e => setAddress(e.target.value)} style={{ ...inputStyle, marginBottom: 14 }} />
      <button style={{
        width: "100%", background: "#0a3d91", color: "#fff",
        border: "none", borderRadius: 3, padding: "13px",
        fontSize: 15, fontWeight: 700, cursor: "pointer",
        fontFamily: "inherit", letterSpacing: 0.1,
      }}>
        Check availability
      </button>
      <div style={{ fontSize: 12, color: "#777", marginTop: 10, textAlign: "center" }}>
        Sky TV customers get exclusive deals. <a href="#">Sign in ›</a>
      </div>
    </div>
  );
}

function UspItem({ icon, badge, title, desc }) {
  return (
    <div className="usp-item">
      <div style={{ marginBottom: 12 }}>{icon}</div>
      <div>
        {badge && <div style={{ fontSize: 20, fontWeight: 900, color: "#1a1a1a", marginBottom: 2 }}>{badge}</div>}
        <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>{title}</div>
        <div style={{ fontSize: 12, color: "#666", lineHeight: 1.5 }}>{desc}</div>
      </div>
    </div>
  );
}

function SpeedCard({ name, speed, desc, img, bg }) {
  return (
    <div className="speed-card">
      <div style={{ padding: "16px 16px 10px" }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: "#1a1a1a" }}>{name}</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#444", margin: "3px 0 8px" }}>{speed}</div>
        <div style={{ fontSize: 13, color: "#555", lineHeight: 1.5 }}>{desc}</div>
      </div>
      <div style={{ height: 165, background: bg, overflow: "hidden" }}>
        <img src={img} alt={name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </div>
    </div>
  );
}

function StepItem({ n, title, desc }) {
  return (
    <div className="step-item">
      <div style={{
        width: 46, height: 46, borderRadius: "50%",
        border: "2px solid #bbb",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 20, fontWeight: 700, color: "#1a1a1a",
        margin: "0 auto 14px",
      }}>{n}</div>
      <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8, color: "#1a1a1a" }}>{title}</div>
      <div style={{ fontSize: 13, color: "#555", lineHeight: 1.6 }}>{desc}</div>
    </div>
  );
}

function ExploreCard({ img, label, desc, link, link2 }) {
  return (
    <div className="explore-card">
      <div style={{ height: 190, overflow: "hidden", background: "#eee" }}>
        <img src={img} alt={label} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </div>
      <div style={{ padding: "12px 2px 18px" }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", marginBottom: 5 }}>{label}</div>
        <div style={{ fontSize: 12, color: "#666", marginBottom: 8, lineHeight: 1.5 }}>{desc}</div>
        <a href="#" style={{ fontSize: 12, color: "#e4006d", fontWeight: 600 }}>{link}</a>
        {link2 && <><br /><a href="#" style={{ fontSize: 12, color: "#e4006d" }}>{link2}</a></>}
      </div>
    </div>
  );
}

const FAQS = [
  { q: "What is One Touch Switch for Broadband?", a: ["One Touch Switch means it's never been easier to switch to Sky. A new industry regulation means that you don't need to speak to your old provider when you switch. Just give us a few details and we'll handle the rest."] },
  { q: "When can I use One Touch Switch to change my broadband provider?", a: ["One Touch Switch is ready for you to use now. Check what speeds are available at your address and complete your order. You'll need to give us a few details and then we'll speak to your old provider so you don't have to."] },
  { q: "Do I need to tell my old broadband provider if I join Sky with one touch switch?", a: ["No we'll speak to your old provider so you don't have to. Just give us a few details when you check out and we'll handle the rest."] },
  { q: "What does 'full fibre' and 'direct to your home' mean?", a: [
    "Full fibre broadband, also known as FTTP (Fibre to the premises) and FTTH (fibre to the home) delivers broadband directly into your home via the ultra-fast fibre optic cable.",
    "No cabinet, no copper cables, no sharing internet with the neighbours.",
    "It's ultra reliable broadband for the busiest homes. Streaming, downloading, video calls, gaming. All at the same time.",
    "Traditional fibre broadband, also known as FTTC (fibre to the cabinet) delivers broadband to the cabinet in your area via fibre optic cable.",
    "But copper wire delivers broadband to your home from the cabinet, and is much slower. Distance from the cabinet and how many households online at all once can slow your internet.",
  ]},
  { q: "What broadband speed do I need?", a: [
    "It depends on how many people live in your household and how much internet they use.",
    "If your household has lots of internet activity such as working from home, making video calls, streaming on different devices and gaming online, then the faster the broadband you can get the better your experience will be.",
  ]},
  { q: "What broadband speeds can I get?", a: ["Use our availability checker to see which Sky Broadband packages are available to your home."] },
  { q: "How long will broadband installation take?", a: [
    "When you sign up to Sky Broadband there are two different ways you can get started.",
    "If you already have an active line an engineer won't be needed and you can connect your Sky Hub yourself on the install date. If you don't already have an active line an Openreach engineer will need to install your broadband service. This includes replacing a master socket if the existing one is faulty, or installing a new one if needed. It's worth noting, however, that they will not move an existing socket.",
  ]},
  { q: "If I don't make calls, do I need line rental?", a: ["All our broadband services are inclusive of landline rental and Sky Pay As You Talk (£2pm) as standard."] },
  { q: "If I already have a router, can I use the same one when I join Sky?", a: ["When you join Sky you will be sent a new compatible Sky Hub, which allows you to check your speeds and connected devices online or through the My Sky app. It also allows our tech team to carry out checks if there are any problems with your service."] },
  { q: "Can I keep my phone number?", a: ["Yes in most cases you can keep your current phone number. We'll let you know if we need to provide you with a new number when you place an order for Sky Broadband."] },
  { q: "If I already have an active phone line and broadband provided do I need to pay for a new line?", a: ["If you currently have an active service, you'll be happy to know that Sky will take over the line at no extra cost."] },
];

function FaqSection() {
  const [open, setOpen] = useState(true);
  return (
    <div>
      {FAQS.map((f, i) => (
        <div key={i} className="faq-row">
          <button className="faq-q" >
            <span style={{ flex: 1, paddingRight: 16 }}>{f.q}</span>
            <span style={{
              fontSize: 22, color: "#1a1a1a", fontWeight: 300,
              transform: open === i ? "rotate(45deg)" : "none",
              transition: "transform 0.2s",
              display: "inline-block",
              lineHeight: 1,
            }}>+</span>
          </button>
         
            <div className="faq-a">
              {f.a.map((p, j) => (
                <p key={j} style={{ marginBottom: j < f.a.length - 1 ? 10 : 0 }}>{p}</p>
              ))}
            </div>
          
        </div>
      ))}
      <div style={{ borderTop: "1px solid #ddd" }} />
    </div>
  );
}

/* Icons */
function SpeedIcon() {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
      <circle cx="19" cy="19" r="18" stroke="#ddd" strokeWidth="1.5"/>
      <path d="M9 25 Q19 9 29 19" stroke="#333" strokeWidth="2" fill="none" strokeLinecap="round"/>
      <circle cx="19" cy="19" r="2.5" fill="#e4006d"/>
      <line x1="19" y1="19" x2="24" y2="13" stroke="#e4006d" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
function ReliableIcon() {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
      <circle cx="19" cy="19" r="18" stroke="#ddd" strokeWidth="1.5"/>
      <path d="M12 19 l5 5 9-9" stroke="#333" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
function PoundIcon() {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
      <circle cx="19" cy="19" r="18" stroke="#ddd" strokeWidth="1.5"/>
      <text x="19" y="24" textAnchor="middle" fontSize="17" fontWeight="700" fill="#333" fontFamily="Arial">£</text>
    </svg>
  );
}
